import * as React from "react";
import { StoreContext } from "../../../store/StoreProvider";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { MultiInput } from "../../MultiInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import TextFieldDefault, { TextFieldProps } from "@mui/material/TextField";

var ACTIVE_UPDATE = "";

type InputCustomProps = {};
type InputProps = InputCustomProps & TextFieldProps;
const TextField: any = React.forwardRef((props: InputProps, defRef: any) => {
  return <TextFieldDefault {...props} />;
});

const UserData = () => {
  const [store, dispatch] = React.useContext(StoreContext);
  const [showUpd, setUpd] = React.useState(false);

  const [docType, setDocType] = React.useState(
    store?.inputSelectCountry?.do_tipDoc || "CI"
  );
  const [docTypeNac, setDocTypeNac] = React.useState(
    store?.inputSelectCountry?.numDocNac || ""
  );
  
  const [numberPhone, setNumberPhone] = React.useState(
    store?.inputSelectCountry?.numPhone || ""
  );

  const { battery } = store;

  let num = 0;
  for (let index = 0; index < battery?.DatosUsuario.length; index++) {
    if (!!battery?.DatosUsuario[index].Valor) num++;
  }

  const updateRequest = () => {
    ACTIVE_UPDATE = "USER";
    let btn: any = document?.getElementById("btn-submit");
    btn?.click();
  };

  let update = Number(battery?.Id) !== -1 ? true : false;
  if (!!battery?.TienePreTarjeta) {
    update = true;
  }

  let doc: any = battery?.DatosUsuario.find(
    ({ DescDet }: any) =>
      DescDet.toLocaleLowerCase() ===
      "Documento de identificación".toLocaleLowerCase()
  );

  let numDocumentValue = doc.Valor.split(" ");

  if (numDocumentValue.length > 1) {
    if (numDocumentValue.length === 2) {
      if (docTypeNac !== numDocumentValue[1]) {
        setDocTypeNac(numDocumentValue[1]);
      }
    }

    doc = {
      ...doc,
      Valor: numDocumentValue[1],
    };
  }

  doc = {
    ...doc
  };

  let phone: any = battery?.DatosUsuario.find(
    ({ DescDet }: any) =>
      DescDet.toLocaleLowerCase() === "Celular de cliente".toLocaleLowerCase()
  );

  if (!!phone.Valor) {
    let numPhoneValue = phone.Valor.split(" ");

    if (numPhoneValue.length > 1) {
      if (numberPhone !== numPhoneValue[1]) {
        setNumberPhone(numPhoneValue[1]);
      }

      phone = {
        ...phone,
        Valor: numPhoneValue[1],
      };
    }
  }

  let email: any = battery?.DatosUsuario.find(
    ({ DescDet }: any) =>
      DescDet.toLocaleLowerCase() === "Correo de cliente".toLocaleLowerCase()
  );

  let name: any = battery?.DatosUsuario.find(
    ({ DescDet }: any) =>
      DescDet.toLocaleLowerCase() === "Nombre cliente".toLocaleLowerCase()
  );

  const formatCedula = (value: string) => {
    
    const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    const limitedValue = cleanValue.slice(0, 8);

    // Aplicar formato x-xxx-xxxx
    if (limitedValue.length <= 1) {
      return limitedValue;
    } else if (limitedValue.length <= 4) {
      return `${limitedValue[0]}-${limitedValue.slice(1)}`;
    } else {
      return `${limitedValue[0]}-${limitedValue.slice(1, 4)}-${limitedValue.slice(4)}`;
    }
  };

  return (
    <details
      className={`details active ${num !== battery?.DatosUsuario.length ? "" : "success"
        }`}
    >
      <summary>
        <strong>Datos de cliente</strong>
        <div className="arrow-container d-flex">
          <span
          >{`(${num}/${battery?.DatosUsuario.length})`}</span>
          <ArrowDropDownIcon />
        </div>
      </summary>
      <div className="details-body">
        <div className="row" style={{ display: "flex" }}>
          <div className="col-sm-2" style={{ flex: 0.7 }}>
            <FormControl fullWidth style={{ marginTop: 5 }}>
              <InputLabel id="demo-simple-select-label">
                Tipo de Doc.
              </InputLabel>
              <Select
                id="tipDoc"
                value={docType}
                label="Tipo de documento"
                onChange={(event) => {
                  setDocType(event.target.value);
                }}
                disabled={update}
                data-keyword={"Tipo de documento"}
                data-parent={"Tipo de documento"}
              >
                <MenuItem value={"CI"}>CI</MenuItem>
                
              </Select>
            </FormControl>
          </div>

          <div className="col-sm-10" style={{ flex: 3 }}>
            <FormControl fullWidth style={{ marginTop: 5 }}>
              <TextField
                fullWidth
                id="docNac"
                disabled={update}
                required={doc?.FlgObligatorio}
                className={` ${"uppercase"} ${update ? "input-success" : ""}`}
                label={"Número de documento"}
                data-parent={"DatosUsuario"}
                data-keyword={JSON.stringify(doc)}
                variant="outlined"
                value={docTypeNac}
                onChange={(event: any) => {
                  setDocTypeNac(event.target.value);
                }}
                type={"text"}
                InputProps={{
                  inputProps: {
                    minLength: doc.Minimo,
                    maxLength: doc.Maximo,
                  },
                }}
                step={"any"}
              />
            </FormControl>
          </div>
        </div>
        <div className="row" style={{ display: "flex" }}>
          <div className="col-sm-1" style={{ flex: 0.7 }}>
            <span
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "20px 0",
                fontSize: "1.1em",
                color: "#383838",
              }}
            >
              +507
            </span>
          </div>
          <div className="col-sm-10" style={{ flex: 3 }}>

            <FormControl fullWidth style={{ marginTop: 5 }}>
              <TextField
                fullWidth
                id="numPhone"
                data={phone}
                disabled={update}
                required={phone?.FlgObligatorio}
                className={` ${"uppercase"} ${update ? "input-success" : ""}`}
                label={"Celular"}
                data-parent={"DatosUsuario"}
                data-keyword={JSON.stringify(phone)}
                variant="outlined"
                value={numberPhone}
                autoComplete="off"
                onChange={(event: any) => {
                  setNumberPhone(event.target.value);
                }}
                type={"text"}
                InputProps={{
                  inputProps: {
                    minLength: phone.Minimo,
                    maxLength: phone.Maximo,
                  },
                }}
                step={"any"}
              />
            </FormControl>
          </div>
        </div>
        <MultiInput
          data={email}
          disabled={update}
          requred={email?.FlgObligatorio}
          placeholder={email.PlaceHolder}
          className="input-battery"
          parent="DatosUsuario"
          keyword={JSON.stringify(email)}
          update={update}
          onChange={() => {
            if (!showUpd) setUpd(true);
          }}
          callback={updateRequest}
        />
        <MultiInput
          data={name}
          disabled={update}
          requred={name?.FlgObligatorio}
          placeholder={name.PlaceHolder}
          className="input-battery"
          parent="DatosUsuario"
          keyword={JSON.stringify(name)}
          update={update}
          onChange={() => {
            if (!showUpd) setUpd(true);
          }}

          callback={updateRequest}
        />
      </div>
    </details>
  );
};

export const Panama = (props: any) => {

  return (
    <>
      <UserData />
    </>
  );
};
